import "./FormContainer.css";

import classNames from "classnames";
import { PropsWithChildren } from "react";

interface FormContainerProps {
  oneColumnMax?: boolean;
  twoColumnsMax?: boolean;
  style?: React.CSSProperties;
}

const FormContainer: React.FC<PropsWithChildren<FormContainerProps>> = ({
  children,
  oneColumnMax,
  twoColumnsMax,
  style,
}) => {
  return (
    <div
      className={classNames("form-container", {
        "form-container--one-column-max": oneColumnMax,
        "form-container--two-columns-max": twoColumnsMax,
      })}
      style={style}
    >
      {children}
    </div>
  );
};

export default FormContainer;
